import { UUID } from "../generic/uuid";
import {
  createUserOrganisationDtoFromAdminUserOrganisationModel,
  UserOrganisationModel,
} from "./userOrganisation";
import { createPersonDtoFromAdminPersonModel, PersonModel } from "./person";
import { UserStatusModel } from "./userStatus";
import { createRoleDtoFromAdminRoleModel, RoleModel } from "./role";
import {
  createPermissionDtoFromAdminPermissionModel,
  PermissionModel,
} from "./permission";
import { createImageDtoFromAdminImageModel, ImageModel } from "./image";
import { DateTimeFormatEnum, TimezoneEnum } from "@vini-wine/core-enums";
import {
  PermissionDto,
  RoleDto,
  UserAccountDto,
  UserOrganisationDto,
} from "@vini-wine/core-dtos";

export interface UserAccountModel extends UUID {
  // default includes
  person: PersonModel;

  // available includes
  selectedUserOrganisation?: UserOrganisationModel | null;
  permissions?: PermissionModel[];
  roles?: RoleModel[];
  userOrganisations?: UserOrganisationModel[];
  numNotificationsUnPreRead?: number;
  avatar?: ImageModel;

  // transform
  status: UserStatusModel;
  email: string;
  emailVerified: boolean;
  lastLoginAt: Date;
  defaultTimezone: TimezoneEnum;
  defaultDateTimeFormat: DateTimeFormatEnum;
  createdAt: Date;
  updatedAt: Date;
  tourSkippedAt: Date | null;
}

export const createUserAccountDtoFromAdminUserAccountModel = (
  userAccount: UserAccountModel,
): UserAccountDto => {
  let permissions: PermissionDto[] | undefined = undefined;
  if (userAccount.permissions) {
    permissions = [];
    for (let i = 0; i < userAccount.permissions.length; i += 1) {
      permissions.push(
        createPermissionDtoFromAdminPermissionModel(userAccount.permissions[i]),
      );
    }
  }

  let roles: RoleDto[] | undefined = undefined;
  if (userAccount.roles) {
    roles = [];
    for (let i = 0; i < userAccount.roles.length; i += 1) {
      roles.push(createRoleDtoFromAdminRoleModel(userAccount.roles[i]));
    }
  }

  let userOrganisations: UserOrganisationDto[] | undefined = undefined;
  if (userAccount.userOrganisations) {
    userOrganisations = [];
    for (let i = 0; i < userAccount.userOrganisations.length; i += 1) {
      userOrganisations.push(
        createUserOrganisationDtoFromAdminUserOrganisationModel(
          userAccount.userOrganisations[i],
        ),
      );
    }
  }

  return {
    uuid: userAccount.uuid,
    status: userAccount.status,
    email: userAccount.email,
    emailVerified: userAccount.emailVerified,
    lastLoginAt: userAccount.lastLoginAt,
    defaultTimezone: userAccount.defaultTimezone,
    defaultDateTimeFormat: userAccount.defaultDateTimeFormat,
    createdAt: userAccount.createdAt,
    updatedAt: userAccount.updatedAt,
    tourSkippedAt: userAccount.tourSkippedAt,

    person: createPersonDtoFromAdminPersonModel(userAccount.person),
    selectedUserOrganisation: userAccount.selectedUserOrganisation
      ? createUserOrganisationDtoFromAdminUserOrganisationModel(
          userAccount.selectedUserOrganisation,
        )
      : undefined,
    permissions,
    roles,
    userOrganisations: undefined,
    numNotificationsUnPreRead: userAccount.numNotificationsUnPreRead,
    avatar: userAccount.avatar
      ? createImageDtoFromAdminImageModel(userAccount.avatar)
      : undefined,
  };
};
